import type { Deal } from '@graphql/react-apollo'

export const isDeal = (offer: unknown): offer is Deal =>
  offer !== null &&
  typeof offer === 'object' &&
  (offer as { __typename: string }).__typename === 'Deal'
